import { render } from "./GastronomyPage.vue?vue&type=template&id=7afb9b0a"
import script from "./GastronomyPage.vue?vue&type=script&lang=js"
export * from "./GastronomyPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/42/uchowanca/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__